import moment from 'moment'
import docendo from '../docendo'
import eventbus from '../eventbus'
import {
  loadEventsForSubject,
  addTeacherToScheduledEventsFromDate,
  removeTeacherFromScheduledEventsFromDate
} from '../utils/assignTeacherToScheduledEvents'

export default {
  data () {
    return {
      showAssignTeacherToEventsConfirm: false,
      assignTeacherToEventsAction: 'add',
      assignTeacherToEventsKind: 'user',
      assignTeacherToEventsCalendarIds: [],
      assignTeacherToEventsQueue: [],
      askedTeacherAssignKeys: [],
      scheduledEventsForAssign: null,
      isLoadingScheduledEventsForAssign: false,
      continueUpdateAfterTeacherAssign: false
    }
  },
  computed: {
    assignTeacherToEventsNames () {
      return this.assignTeacherToEventsCalendarIds
        .map(calendarId => {
          const calendar = this.allCalendarsInHash && this.allCalendarsInHash[calendarId]
          return calendar && calendar.name ? calendar.name : ''
        })
        .filter(name => name)
        .join(', ')
    },
    assignTeacherToEventsInitialDate () {
      const weekStart = this.$store.getters.calendarStartDate
      if (weekStart) {
        return moment(weekStart).format('YYYY-MM-DD')
      }
      return moment().format('YYYY-MM-DD')
    }
  },
  methods: {
    teacherAssignKey (action, calendarId) {
      return action + ':' + calendarId
    },
    currentIdsForAssignKind (kind) {
      if (kind === 'klass') return this.klassCalendarIds || []
      if (kind === 'room') return this.roomCalendarIds || []
      return this.userCalendarIds || []
    },
    lockedIdsForAssignKind (kind) {
      if (kind === 'klass') {
        // Brikkens primære kalender (ejer-klassen) kan ikke fjernes her
        return this.calendarId ? [this.calendarId] : []
      }
      if (kind === 'room') return []
      return this.lockedTeacherCalendarIds || []
    },
    calendarIdsAlreadyOnSubjectForKind (kind) {
      if (!this.editSubject) return []
      const raw = this.editSubject.calendar_ids
        ? this.editSubject.calendar_ids
        : (this.editSubject.cals || []).map(cal => cal.id)
      return raw.filter(id => {
        const calendar = this.allCalendarsInHash && this.allCalendarsInHash[id]
        if (!calendar || calendar.type !== kind) return false
        if (kind === 'klass' && id === this.calendarId) return false
        return true
      })
    },
    addedCalendarIdsForAssign (selectedItems, kind) {
      const newIds = (selectedItems || []).map(item => item.id)
      const currentIds = this.currentIdsForAssignKind(kind)
      const locked = this.lockedIdsForAssignKind(kind)
      const alreadyOnSubject = this.calendarIdsAlreadyOnSubjectForKind(kind)
      return newIds.filter(id => {
        return currentIds.indexOf(id) < 0 &&
          locked.indexOf(id) < 0 &&
          alreadyOnSubject.indexOf(id) < 0
      })
    },
    removedCalendarIdsForAssign (selectedItems, kind) {
      const newIds = (selectedItems || []).map(item => item.id)
      const currentIds = this.currentIdsForAssignKind(kind)
      const locked = this.lockedIdsForAssignKind(kind)
      return currentIds.filter(id => {
        return newIds.indexOf(id) < 0 && locked.indexOf(id) < 0
      })
    },
    unaskedIdsForAssignAction (action, kind) {
      const locked = this.lockedIdsForAssignKind(kind)
      const alreadyOnSubject = this.calendarIdsAlreadyOnSubjectForKind(kind)
      const currentIds = this.currentIdsForAssignKind(kind)
      if (action === 'add') {
        return currentIds.filter(id => {
          return alreadyOnSubject.indexOf(id) < 0 &&
            locked.indexOf(id) < 0 &&
            this.askedTeacherAssignKeys.indexOf(this.teacherAssignKey('add', id)) < 0
        })
      }
      return alreadyOnSubject.filter(id => {
        return currentIds.indexOf(id) < 0 &&
          locked.indexOf(id) < 0 &&
          this.askedTeacherAssignKeys.indexOf(this.teacherAssignKey('remove', id)) < 0
      })
    },
    assignTeacherSchoolId () {
      if (this.editSubject && this.editSubject.school_id) return this.editSubject.school_id
      if (this.schoolId) return this.schoolId
      return window.SCHOOL && window.SCHOOL.id ? window.SCHOOL.id : null
    },
    isAssignTeacherToEventsEnabled () {
      return !!this.isInDCalendar
    },
    onTeacherSelectionUpdated (users) {
      this.onCalendarSelectionUpdatedForAssign(users, 'user')
    },
    onKlassSelectionUpdated (klasses) {
      this.onCalendarSelectionUpdatedForAssign(klasses, 'klass')
    },
    onRoomSelectionUpdated (rooms) {
      this.onCalendarSelectionUpdatedForAssign(rooms, 'room')
    },
    onCalendarSelectionUpdatedForAssign (selectedItems, kind) {
      const addedIds = this.addedCalendarIdsForAssign(selectedItems, kind)
      const removedIds = this.removedCalendarIdsForAssign(selectedItems, kind)
      const newIds = selectedItems.map(item => item.id)
      if (kind === 'klass') {
        this.klassCalendarIds = newIds
      } else if (kind === 'room') {
        this.roomCalendarIds = newIds
      } else {
        this.userCalendarIds = newIds
      }
      if (!this.editSubject || !this.isAssignTeacherToEventsEnabled()) return
      if (addedIds.length > 0) {
        this.maybeAskAssignTeacherToScheduledEvents(addedIds, 'add', kind)
      }
      if (removedIds.length > 0) {
        this.maybeAskAssignTeacherToScheduledEvents(removedIds, 'remove', kind)
      }
    },
    isTeacherAssignPending (calendarId, action) {
      const inQueue = this.assignTeacherToEventsQueue.some(item => {
        return item.calendarId === calendarId && item.action === action
      })
      const inModal = this.assignTeacherToEventsAction === action &&
        this.assignTeacherToEventsCalendarIds.indexOf(calendarId) > -1
      return inQueue || inModal
    },
    maybeAskAssignTeacherToScheduledEvents (calendarIds, action, kind) {
      const theKind = kind || 'user'
      if (!this.isAssignTeacherToEventsEnabled()) return
      if (!this.editSubject || !calendarIds || !calendarIds.length) return
      const toAsk = calendarIds.filter(id => {
        return !this.isTeacherAssignPending(id, action) &&
          this.askedTeacherAssignKeys.indexOf(this.teacherAssignKey(action, id)) < 0
      })
      if (!toAsk.length) return
      this.assignTeacherToEventsQueue = this.assignTeacherToEventsQueue.concat(
        toAsk.map(id => ({calendarId: id, action: action, kind: theKind}))
      )
      if (this.showAssignTeacherToEventsConfirm || this.isLoadingScheduledEventsForAssign) {
        return
      }
      this.loadScheduledEventsThenAsk()
    },
    loadScheduledEventsThenAsk () {
      if (this.scheduledEventsForAssign) {
        this.openAssignTeacherToEventsIfNeeded()
        return
      }
      this.isLoadingScheduledEventsForAssign = true
      loadEventsForSubject(this.editSubject.id, events => {
        this.scheduledEventsForAssign = events
        this.isLoadingScheduledEventsForAssign = false
        this.openAssignTeacherToEventsIfNeeded()
      }, () => {
        this.scheduledEventsForAssign = []
        this.isLoadingScheduledEventsForAssign = false
        this.markQueuedTeachersAsAsked()
        this.finishTeacherAssignAndMaybeUpdate()
      })
    },
    openAssignTeacherToEventsIfNeeded () {
      const queued = this.assignTeacherToEventsQueue.slice()
      if (!queued.length) {
        this.finishTeacherAssignAndMaybeUpdate()
        return
      }
      if (!this.scheduledEventsForAssign || this.scheduledEventsForAssign.length < 1) {
        this.markQueuedTeachersAsAsked()
        this.finishTeacherAssignAndMaybeUpdate()
        return
      }
      const action = queued[0].action
      const kind = queued[0].kind || 'user'
      const sameBatch = queued.filter(item => item.action === action && (item.kind || 'user') === kind)
      this.assignTeacherToEventsQueue = queued.filter(item => item.action !== action || (item.kind || 'user') !== kind)
      this.assignTeacherToEventsAction = action
      this.assignTeacherToEventsKind = kind
      this.assignTeacherToEventsCalendarIds = sameBatch.map(item => item.calendarId)
      this.showAssignTeacherToEventsConfirm = true
    },
    markQueuedTeachersAsAsked () {
      this.assignTeacherToEventsQueue.forEach(item => {
        this.markTeachersAsAsked([item.calendarId], item.action)
      })
      this.assignTeacherToEventsQueue = []
    },
    markTeachersAsAsked (calendarIds, action) {
      const theAction = action || this.assignTeacherToEventsAction
      ;(calendarIds || []).forEach(id => {
        const key = this.teacherAssignKey(theAction, id)
        if (this.askedTeacherAssignKeys.indexOf(key) < 0) {
          this.askedTeacherAssignKeys.push(key)
        }
      })
    },
    onAssignTeacherToEventsConfirm (payload) {
      const fromDate = payload && payload.fromDate ? payload.fromDate : payload
      const enddate = payload && payload.enddate ? payload.enddate : null
      const calendarIds = this.assignTeacherToEventsCalendarIds.slice()
      const action = this.assignTeacherToEventsAction
      this.markTeachersAsAsked(calendarIds, action)
      this.showAssignTeacherToEventsConfirm = false
      this.assignTeacherToEventsCalendarIds = []
      this.applyTeacherChangeToBrickAndEvents(calendarIds, fromDate, action, () => {
        this.processNextAssignTeacherOrUpdate()
      }, enddate)
    },
    onAssignTeacherToEventsSkip () {
      this.markTeachersAsAsked(this.assignTeacherToEventsCalendarIds, this.assignTeacherToEventsAction)
      this.showAssignTeacherToEventsConfirm = false
      this.assignTeacherToEventsCalendarIds = []
      this.processNextAssignTeacherOrUpdate()
    },
    processNextAssignTeacherOrUpdate () {
      if (this.assignTeacherToEventsQueue.length > 0) {
        this.openAssignTeacherToEventsIfNeeded()
        return
      }
      this.finishTeacherAssignAndMaybeUpdate()
    },
    finishTeacherAssignAndMaybeUpdate () {
      if (!this.continueUpdateAfterTeacherAssign) return
      this.continueUpdateAfterTeacherAssign = false
      this.doUpdateSubject()
    },
    shouldWaitForTeacherAssignBeforeUpdate () {
      if (!this.isAssignTeacherToEventsEnabled() || !this.editSubject) return false
      if (this.showAssignTeacherToEventsConfirm || this.isLoadingScheduledEventsForAssign) {
        this.continueUpdateAfterTeacherAssign = true
        return true
      }
      let foundUnasked = false
      ;['user', 'klass', 'room'].forEach(kind => {
        const unaskedAdd = this.unaskedIdsForAssignAction('add', kind)
        const unaskedRemove = this.unaskedIdsForAssignAction('remove', kind)
        if (unaskedAdd.length < 1 && unaskedRemove.length < 1) return
        foundUnasked = true
        this.continueUpdateAfterTeacherAssign = true
        if (unaskedAdd.length) this.maybeAskAssignTeacherToScheduledEvents(unaskedAdd, 'add', kind)
        if (unaskedRemove.length) this.maybeAskAssignTeacherToScheduledEvents(unaskedRemove, 'remove', kind)
      })
      return foundUnasked
    },
    applyTeacherChangeToBrickAndEvents (calendarIds, fromDate, action, done, enddate) {
      if (!calendarIds.length) {
        if (done) done()
        return
      }
      const schoolId = this.assignTeacherSchoolId()
      const subjectId = this.editSubject.id
      const isRemove = action === 'remove'
      const applyOnEvents = isRemove
        ? removeTeacherFromScheduledEventsFromDate
        : addTeacherToScheduledEventsFromDate
      let remaining = calendarIds.length
      const next = () => {
        remaining--
        if (remaining < 1) {
          this.refreshCalendarAfterTeacherAssign()
          if (done) done()
        }
      }
      calendarIds.forEach(calendarId => {
        const changes = isRemove
          ? {remove_calendar_id: calendarId}
          : {add_calendar_id: calendarId}
        docendo.bulkUpdateSubjects(schoolId, [subjectId], changes, data => {
          if (Array.isArray(data)) {
            const subjects = this.$store.state.subjects && this.$store.state.subjects.subjects
            data.forEach(subject => {
              if (subjects && subjects.some(item => item.id === subject.id)) {
                this.$store.commit('updateSubject', subject)
              }
            })
          }
        })
        applyOnEvents({
          schoolId: schoolId,
          calendarId: calendarId,
          fromDate: fromDate,
          enddate: enddate || null,
          events: this.scheduledEventsForAssign
        }, result => {
          if (result && result.reason === 'no_events_from_date') {
            eventbus.toast = {
              text: this.assignTeacherToEventsI18n().no_events_from_date,
              success: false
            }
          } else {
            eventbus.toast = {
              text: this.$t('vue2.substitution.lessons_updated'),
              success: true
            }
          }
          next()
        }, () => {
          eventbus.toast = {text: this.$t('vue2.sms.an_error_occured'), success: false}
          next()
        })
      })
    },
    refreshCalendarAfterTeacherAssign () {
      const calendarState = this.$store.state.calendar
      const calendarId = calendarState && calendarState.calendarId
      if (calendarId) {
        this.$store.dispatch('readCalendarEvents', {
          calIds: [calendarId],
          start: this.$store.getters.calendarStartDate,
          end: this.$store.getters.calendarEndDate,
          andReadSubjects: true
        })
        return
      }
      if (this.isInDCalendar) {
        this.$store.dispatch('readCalendarSubjects')
      }
    },
    assignTeacherToEventsI18n () {
      const locale = this.locale || 'da'
      const texts = {
        da: {no_events_from_date: 'Der er ingen skemalagte brikker fra den valgte dato'},
        en: {no_events_from_date: 'There are no scheduled lessons from the selected date'},
        nb: {no_events_from_date: 'Det er ingen timeplanlagte brikker fra den valgte dato'}
      }
      return texts[locale] || texts.da
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/assignTeacherToScheduledEvents.js